/* Cloud City Vapes: shop behaviour for the Liquid Glass theme, part 1.
   Cart drawer and search suggestions (collection filters and product options
   are in liquid-glass-catalog.js).
   Plain browser JavaScript, no framework, no scroll hijacking. Loaded with
   defer after theme.js. Everything degrades: without this file the product
   form posts to /cart, the filters form reloads the page, the search box
   submits to /search, and the option selects are plain selects. */
(function () {
  'use strict';

  var routes = window.lgRoutes || {};
  routes.root = routes.root || '/';
  routes.cartAdd = routes.cartAdd || '/cart/add';
  routes.cartChange = routes.cartChange || '/cart/change';
  routes.cartUpdate = routes.cartUpdate || '/cart/update';
  routes.cart = routes.cart || '/cart';
  routes.predictive = routes.predictive || '/search/suggest';
  routes.search = routes.search || '/search';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, ms) {
    var t;
    return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); };
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function formatMoney(amount) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    var n = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format(n); }
    catch (e) { return n.toFixed(2); }
  }
  function focusables(root) {
    return qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  /* ------------------------------------------------------------------ */
  /* 1. Cart drawer                                                      */
  /* ------------------------------------------------------------------ */
  var Cart = {
    root: null,
    opener: null,
    busy: false,

    init: function () {
      this.root = qs('#LgCartDrawer');
      if (!this.root) return;
      var self = this;

      // Add to cart, anywhere on the page. Capture phase so the theme's own
      // handler never runs for these forms.
      document.addEventListener('submit', function (evt) {
        var form = evt.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
        if (form.hasAttribute('data-lg-no-ajax')) return;
        evt.preventDefault();
        evt.stopImmediatePropagation();
        self.add(form);
      }, true);

      document.addEventListener('click', function (evt) {
        var t = evt.target.closest ? evt.target.closest('[data-lg-cart-open]') : null;
        if (t && !evt.metaKey && !evt.ctrlKey && !evt.shiftKey) {
          evt.preventDefault();
          self.open(t);
        }
      });

      this.bindDrawer();
      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape' && self.isOpen()) self.close();
      });
    },

    bindDrawer: function () {
      var self = this, root = this.root;
      root.addEventListener('click', function (evt) {
        var t = evt.target;
        if (t.closest('[data-lg-cart-close]')) { evt.preventDefault(); self.close(); return; }
        var minus = t.closest('[data-lg-qty-minus]');
        var plus = t.closest('[data-lg-qty-plus]');
        var remove = t.closest('[data-lg-remove-line]');
        if (minus || plus) {
          var wrap = (minus || plus).closest('[data-lg-qty]');
          var input = qs('[data-lg-qty-input]', wrap);
          var q = parseInt(input.value, 10) || 0;
          q = minus ? Math.max(0, q - 1) : q + 1;
          input.value = q;
          var line = parseInt(input.getAttribute('data-lg-line'), 10);
          self.refocus = '[data-lg-line="' + line + '"] ' + (minus ? '[data-lg-qty-minus]' : '[data-lg-qty-plus]');
          self.change(line, q);
        } else if (remove) {
          self.refocus = '.lg-cart__close';
          self.change(parseInt(remove.getAttribute('data-lg-remove-line'), 10), 0);
        }
      });
      root.addEventListener('change', function (evt) {
        var input = evt.target.closest('[data-lg-qty-input]');
        if (input) {
          var q = Math.max(0, parseInt(input.value, 10) || 0);
          self.change(parseInt(input.getAttribute('data-lg-line'), 10), q);
        }
        var note = evt.target.closest('[data-lg-cart-note]');
        if (note) self.saveNote(note.value);
      });
      // keep focus inside the dialog
      root.addEventListener('keydown', function (evt) {
        if (evt.key !== 'Tab') return;
        var panel = qs('[data-lg-cart-panel]', root);
        var items = focusables(panel);
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (evt.shiftKey && (document.activeElement === first || document.activeElement === panel)) { evt.preventDefault(); last.focus(); }
        else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
      });
    },

    isOpen: function () { return this.root && this.root.classList.contains('is-open'); },

    open: function (opener) {
      if (!this.root) return;
      this.opener = opener || document.activeElement;
      this.root.hidden = false;
      this.root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lg-cart-open');
      var self = this;
      requestAnimationFrame(function () {
        self.root.classList.add('is-open');
        var panel = qs('[data-lg-cart-panel]', self.root);
        var close = qs('.lg-cart__close', self.root);
        (close || panel).focus({ preventScroll: true });
      });
    },

    close: function () {
      if (!this.root || !this.isOpen()) return;
      var self = this;
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lg-cart-open');
      var done = function () {
        self.root.hidden = true;
        if (self.opener && self.opener.focus) self.opener.focus({ preventScroll: true });
      };
      if (reduceMotion) done(); else setTimeout(done, 300);
    },

    setBusy: function (on) {
      this.busy = on;
      if (this.root) this.root.setAttribute('aria-busy', on ? 'true' : 'false');
    },

    status: function (text, isError) {
      var el = qs('[data-lg-cart-status]', this.root);
      if (!el) return;
      el.textContent = text || '';
      el.classList.toggle('is-error', !!isError);
    },

    /* Swap in the freshly rendered section. */
    render: function (sectionHtml) {
      if (!sectionHtml) return;
      var doc = parseHTML(sectionHtml);
      var fresh = qs('#LgCartDrawer', doc);
      if (!fresh) return;
      var wasOpen = this.isOpen();
      var body = qs('[data-lg-cart-body]', this.root);
      var freshBody = qs('[data-lg-cart-body]', fresh);
      var footer = qs('.lg-cart__footer', this.root);
      var freshFooter = qs('.lg-cart__footer', fresh);
      var title = qs('.lg-cart__title', this.root);
      var freshTitle = qs('.lg-cart__title', fresh);
      if (body && freshBody) body.innerHTML = freshBody.innerHTML;
      if (title && freshTitle) title.innerHTML = freshTitle.innerHTML;
      if (footer && freshFooter) footer.replaceWith(freshFooter);
      else if (footer && !freshFooter) footer.remove();
      else if (!footer && freshFooter) qs('[data-lg-cart-panel]', this.root).appendChild(freshFooter);
      var count = fresh.getAttribute('data-lg-cart-count') || '0';
      this.root.setAttribute('data-lg-cart-count', count);
      this.updateCount(parseInt(count, 10) || 0);
      if (wasOpen) this.root.classList.add('is-open');
      if (wasOpen && this.refocus) {
        var again = qs(this.refocus, this.root) || qs('.lg-cart__close', this.root);
        if (again) again.focus({ preventScroll: true });
        this.refocus = null;
      }
    },

    updateCount: function (n) {
      qsa('[data-lg-cart-count]').forEach(function (el) {
        if (el.id === 'LgCartDrawer') return;
        el.textContent = n;
        el.classList.toggle('is-empty', n === 0);
        el.classList.add('is-bump');
        setTimeout(function () { el.classList.remove('is-bump'); }, 250);
      });
      qsa('.site-header__cart').forEach(function (a) {
        a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
      });
    },

    add: function (form) {
      if (this.busy) return;
      var self = this;
      var button = qs('[type="submit"][name="add"], [data-lg-add]', form);
      var error = qs('[data-lg-form-error]', form);
      if (error) { error.hidden = true; error.textContent = ''; }
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      this.setBusy(true);
      if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }

      fetch(routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message) || 'Could not add this to your bag.');
          self.render(res.data.sections && res.data.sections['cart-drawer']);
          self.status('Added to your bag.');
          self.open(button || form);
          if (window.theme && theme.Notify && theme.Notify.close) { try { theme.Notify.close(); } catch (e) {} }
        })
        .catch(function (err) {
          var msg = err && err.message ? err.message : 'Something went wrong. Please try again.';
          if (error) { error.textContent = msg; error.hidden = false; }
          else self.status(msg, true);
        })
        .then(function () {
          self.setBusy(false);
          if (button) { button.removeAttribute('aria-busy'); button.disabled = false; }
        });
    },

    change: function (line, quantity) {
      if (this.busy || !line) return;
      var self = this;
      this.setBusy(true);
      this.status('');
      fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message) || 'Could not update your bag.');
          self.render(res.data.sections && res.data.sections['cart-drawer']);
          if (quantity === 0) self.status('Item removed.');
        })
        .catch(function (err) { self.status(err.message || 'Something went wrong. Please try again.', true); })
        .then(function () { self.setBusy(false); });
    },

    saveNote: debounce(function (note) {
      fetch(routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note })
      }).catch(function () {});
    }, 400)
  };

  /* ------------------------------------------------------------------ */
  /* 2. Search suggestions                                               */
  /* ------------------------------------------------------------------ */
  var Predict = {
    init: function () {
      var self = this;
      qsa('form[role="search"] input[name="q"]').forEach(function (input) { self.attach(input); });
    },

    attach: function (input) {
      var form = input.form;
      if (!form || form.hasAttribute('data-lg-predict-done')) return;
      form.setAttribute('data-lg-predict-done', '');
      var panel = document.createElement('div');
      panel.className = 'lg-predict';
      panel.hidden = true;
      panel.id = 'lg-predict-' + Math.random().toString(36).slice(2, 8);
      // Inside the glass header the panel would be clipped, so it lives on
      // <body> and is placed under the search box whenever it is shown.
      var floating = !form.closest('.drawer');
      if (floating) { panel.classList.add('lg-predict--floating'); document.body.appendChild(panel); }
      else { form.appendChild(panel); }
      var place = function () {
        if (!floating || panel.hidden) return;
        var r = input.getBoundingClientRect();
        var w = Math.min(416, window.innerWidth - 16);
        panel.style.width = w + 'px';
        panel.style.top = Math.round(r.bottom + 6) + 'px';
        panel.style.left = Math.round(Math.max(8, Math.min(r.right - w, window.innerWidth - w - 8))) + 'px';
      };
      window.addEventListener('resize', place);
      window.addEventListener('scroll', place, { passive: true });
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('aria-controls', panel.id);
      input.setAttribute('aria-expanded', 'false');
      var state = { controller: null, index: -1, items: [] };
      var self = this;

      var close = function () {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        state.index = -1;
      };
      var openIf = function () { if (panel.innerHTML.trim()) { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); place(); } };

      var search = debounce(function () {
        var q = input.value.trim();
        if (q.length < 2) { close(); panel.innerHTML = ''; return; }
        if (state.controller) state.controller.abort();
        state.controller = new AbortController();
        var url = routes.predictive + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,variants.title,tag';
        fetch(url, { signal: state.controller.signal, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error(r.status)); })
          .then(function (json) { self.render(panel, input, json, q, state); openIf(); })
          .catch(function (err) { if (err && err.name === 'AbortError') return; close(); });
      }, 220);

      input.addEventListener('input', search);
      input.addEventListener('focus', function () { if (input.value.trim().length >= 2) openIf(); });
      input.addEventListener('keydown', function (evt) {
        if (panel.hidden) { if (evt.key === 'ArrowDown' && input.value.trim().length >= 2) { search(); } return; }
        var items = state.items;
        if (evt.key === 'ArrowDown' || evt.key === 'ArrowUp') {
          evt.preventDefault();
          if (!items.length) return;
          state.index = evt.key === 'ArrowDown' ? (state.index + 1) % items.length : (state.index - 1 + items.length) % items.length;
          items.forEach(function (el, i) { el.setAttribute('aria-selected', i === state.index ? 'true' : 'false'); });
          input.setAttribute('aria-activedescendant', items[state.index].id);
          items[state.index].scrollIntoView({ block: 'nearest' });
        } else if (evt.key === 'Enter' && state.index >= 0 && items[state.index]) {
          evt.preventDefault();
          window.location.href = items[state.index].getAttribute('href');
        } else if (evt.key === 'Escape') {
          close();
        }
      });
      document.addEventListener('click', function (evt) { if (!form.contains(evt.target) && !panel.contains(evt.target)) close(); });
      form.addEventListener('submit', function () { close(); });
    },

    render: function (panel, input, json, q, state) {
      var res = (json && json.resources && json.resources.results) || {};
      var products = res.products || [];
      var collections = res.collections || [];
      var html = '';
      var n = 0;
      var idBase = panel.id + '-i';
      if (products.length) {
        html += '<p class="lg-predict__heading">Products</p><ul class="lg-predict__group" role="listbox">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : '';
          html += '<li class="lg-predict__item" role="presentation"><a id="' + idBase + (n++) + '" role="option" aria-selected="false" class="lg-predict__link" href="' + p.url + '">' +
            (img ? '<img class="lg-predict__img" src="' + img + '" alt="" width="44" height="44" loading="lazy">' : '<span class="lg-predict__img"></span>') +
            '<span class="lg-predict__text"><span class="lg-predict__title">' + escapeHtml(p.title) + '</span>' +
            (p.vendor ? '<span class="lg-predict__meta">' + escapeHtml(p.vendor) + '</span>' : '') + '</span>' +
            (p.price ? '<span class="lg-predict__price">' + formatMoney(p.price) + '</span>' : '') +
            '</a></li>';
        });
        html += '</ul>';
      }
      if (collections.length) {
        html += '<p class="lg-predict__heading">Collections</p><ul class="lg-predict__group" role="listbox">';
        collections.slice(0, 3).forEach(function (c) {
          html += '<li class="lg-predict__item" role="presentation"><a id="' + idBase + (n++) + '" role="option" aria-selected="false" class="lg-predict__link" href="' + c.url + '"><span class="lg-predict__text"><span class="lg-predict__title">' + escapeHtml(c.title) + '</span></span></a></li>';
        });
        html += '</ul>';
      }
      if (!products.length && !collections.length) {
        html += '<p class="lg-predict__empty">No matches for "' + escapeHtml(q) + '"</p>';
      }
      html += '<a id="' + idBase + (n++) + '" role="option" aria-selected="false" class="lg-predict__all" href="' + routes.search + '?q=' + encodeURIComponent(q) + '">See all results for "' + escapeHtml(q) + '"</a>';
      panel.innerHTML = html;
      state.items = qsa('[role="option"]', panel);
      state.index = -1;
      input.removeAttribute('aria-activedescendant');
    }
  };

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------------ */
  function init() { Cart.init(); Predict.init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { Predict.init(); if (!Cart.root) Cart.init(); });
  window.lgShop = window.lgShop || {};
  window.lgShop.cart = Cart;
  window.lgShop.util = { qs: qs, qsa: qsa, debounce: debounce, parseHTML: parseHTML, reduceMotion: reduceMotion };
})();